export const normalizeDelayDate = (ISOdate: string) => {
  const date = new Date(ISOdate);

  date.setTime(date.getTime() + (date.getTimezoneOffset() + 180) * 60 * 1000);

  console.log(ISOdate, date, date.toISOString());

  return date;
};
